// removed by extract-text-webpack-plugin
module.exports = {"couponButton":"_3NXyII4aOqBKfqfryxf8OO","actionButton":"_1hPWZ2PcmGG2whhOBeh-LX","couponInput":"_18Lm13vWFFhxsfL0vH4NA2","input":"_25OlEvooHJ9orHu-BMlcxe","errorMessage":"_2LxnCjVdG-4WOetQh31FSu","label":"d5a2Y3wJYzZlzuS9rK4Dz","couponBenefit":"_1GES4_R3KRO0qBMoaMGmQz","removeButton":"_127Xp5zRT2ZlZcEsgfOtWJ","inLanding":"QQwhlmrGc29_OFRIlhpDZ","cuponButton":"_3dEdvRi3ChTA3oxOwEPsO1","contactUsRealtor":"cYgAHV7qLJEnt8Jm9XLKr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DiscountCouponContainer/DiscountCouponContainer.scss
// module id = 1800
// module chunks = 0